/* eslint-disable prettier/prettier */
import React from 'react';
import styles from './ViewActivityModal.module.css';
import calander from '../../../../assets/coach/cl.png';
import timee from '../../../../assets/coach/time.png';
import fallbackProfile from '../../../../assets/profile/fallback.png';

export interface Participant {
	id: string;
	name: string;
	avatar?: string;
	role?: string;
}

interface ViewActivityModalProps {
	open: boolean;
	title: string;
	activityType: string;
	activityTypeColor?: string;
	date: string;
	time: string;
	programName: string;
	masterclassTitle: string;
	description: string;
	participants: Participant[];
	onClose: () => void;
}

const ViewActivityModal: React.FC<ViewActivityModalProps> = ({
	open,
	title,
	activityType,
	activityTypeColor,
	date,
	time,
	programName,
	masterclassTitle,
	description,
	participants,
	onClose,
}) => {
	if (!open) return null;

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				{/* Header */}
				<div className={styles.topSection}>
					<div className={styles.badge}>
						<span
							className={styles.badgeDot}
							style={{
								backgroundColor: activityTypeColor || '#EF4444',
							}}
						/>
						{activityType}
					</div>

					<button className={styles.closeBtn} onClick={onClose}>
						✕
					</button>
				</div>

				{/* Title */}
				<h2 className={styles.title}>{title}</h2>

				{/* Meta */}
				<div className={styles.meta}>
					<div className={styles.metaItem}>
						<img
							src={calander}
							alt="calendar"
							className={styles.metaIcon}
						/>

						<span>{date}</span>
					</div>

					<div className={styles.metaDivider} />

					<div className={styles.metaItem}>
						<img
							src={timee}
							alt="time"
							className={styles.metaIcon}
						/>

						<span>{time}</span>
					</div>
				</div>

				{/* Info */}
				<div className={styles.infoSection}>
					<div className={styles.infoRow}>
						<p className={styles.label}>Program Name</p>

						<p className={styles.value}>{programName}</p>
					</div>

					<div className={styles.infoRow}>
						<p className={styles.label}>Masterclass/Session</p>

						<p className={styles.value}>{masterclassTitle}</p>
					</div>
				</div>

				{/* Description */}
				<div className={styles.descriptionSection}>
					<p className={styles.sectionTitle}>Activity Description</p>

					<p className={styles.description}>{description}</p>
				</div>

				{/* Participants */}
				<div className={styles.attendanceSection}>
					<div className={styles.attendanceHeader}>
						<p className={styles.sectionTitle}>
							Participants Attendance
						</p>

						<span className={styles.count}>
							{participants.length} Participants
						</span>
					</div>

					<div className={styles.participantsWrapper}>
						{participants.map(item => (
							<div
								key={item.id}
								className={styles.participantRow}
							>
								<div className={styles.left}>
									{/* <div className={styles.avatar}>
										{item.avatar ? (
											<img
												src={item.avatar}
												alt={item.name}
											/>
										) : (
											item.name.charAt(0)
										)}
									</div> */}
									<div className={styles.avatar}>
  <img
    src={item.avatar || fallbackProfile}
    alt={item.name}
    onError={(e) => {
      e.currentTarget.src = fallbackProfile;
    }}
  />
</div>

									<p className={styles.name}>{item.name}</p>
								</div>

								<span className={styles.role}>
									{item.role || 'Learner'}
								</span>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ViewActivityModal;
